module.exports = __webpack_public_path__ + "media/images/logo-4c7336e45c525947e16847f7a265c355.svg";